/* eslint-disable */

export const getCommonPairsConstants = {
    GET_COMMON_PAIRS_REQUEST: 'GET_COMMON_PAIRS_REQUEST',
    GET_COMMON_PAIRS_SUCCESS: 'GET_COMMON_PAIRS_SUCCESS',
    GET_COMMON_PAIRS_FAILURE: 'GET_COMMON_PAIRS_FAILURE',
};
